import axios from "axios";

export const setUserSessionAuthKey = () => {
  let localData = ""
  let currentURL = window.location.href;
  if (currentURL.includes("external")) {
    localData = localStorage.getItem("RBLExternalUserDetails");
  }
  else {
    localData = localStorage.getItem("rebelSkoolUser");
  }
  let localObject = localData && JSON.parse(localData);
  let userSelectedLanguage;
  userSelectedLanguage = localStorage.getItem("selectedLanguage");

  if (null != localObject) {
    let userSessionAuthKey = localObject["User-Session-Auth-Key"];
    if (userSessionAuthKey != "" && userSessionAuthKey != null) {
      let axiosConfig = {
        headers: {
          "User-Session-Auth-Key": localObject["User-Session-Auth-Key"]
        }
      };

      if (userSelectedLanguage != null && userSelectedLanguage != undefined) {
        axiosConfig.headers["language"] = userSelectedLanguage;
      }

      return axiosConfig;
    } else return false;
  } else return false;
};

export const numberWithCommasAndSpace = (amount) => {
  let amountString = amount.toString();
  if (!amountString.includes(".")) {
    amount = amount.toFixed(2);
  }

  return amount
    .toString()
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ")
    .replace(".", ",");
};

export const numberWithCommasAndSpaceWithoutDecimal = (amount) => {
  let amountString = amount.toString();
  // if (!amountString.includes(".")) {
  //   amount = amount.toFixed(2);
  // }

  return amount
    .toString()
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ")
    .replace(".", ",");
};
export const numberWithSpace = (amount) => {
  let amountString = amount.toString();
  if (!amountString.includes(".")) {
    amount = amount;
  }

  return amount
    .toString()
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ")
    .replace(".", ",");
};

export const previewPdf = (currentReportGUIDFromUrl) => {
  let axiosConfig = setUserSessionAuthKey();
  axios
    .get("/xhtml/convertToPdf?reportGuid=" + currentReportGUIDFromUrl, {
      ...axiosConfig, // Spread axiosConfig to include headers
      responseType: "blob" // Ensure binary data is correctly handled
    })
    .then((response) => {
      // response["Access-Control-Expose-Headers"] = "Content-Disposition";
      const blob = new Blob([response.data], { type: "application/pdf" });
      let url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    });
  return true;
};

export const previewPdfOnSamePage = async (
  currentReportGUIDFromUrl,
  authKey
) => {
  let axiosConfig = "";
  if (authKey != null) {
    axiosConfig = {
      headers: {
        "User-Session-Auth-Key": authKey
      }
    };
  } else axiosConfig = setUserSessionAuthKey();
  try {
    const response = await axios.get(
      "/xhtml/convertToPdf?reportGuid=" + currentReportGUIDFromUrl,
      {
        ...axiosConfig,
        responseType: "blob"
      }
    );
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    return url;
  } catch (error) {
    console.error("Error generating PDF:", error);
    return null;
  }
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email);
};
